export default __webpack_public_path__ + "static/media/neweggbus.008f2126.svg";